import type { FaireProductEntity } from "../../entity_types/product";

export const p_66kdqpvmkw: FaireProductEntity = {
  token: "p_66kdqpvmkw",
  type: "product",
  name: "CZ Evil Eye Charm 18K Gold Plated S.Steel Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/884c595ae06ab8bc11555e3655010d5b5f23da05a48043716da9db04bc808a73.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a87f3abeb1d40511685c362fea3e93f774bdee2c7707bead9b106174dafc96dd.jpeg",
    "https://cdn.faire.com/fastly/91c129fdc8b6649422e8bbdbeadb5c3e558fba24186508b7c55b9fce308d453f.jpeg",
    "https://cdn.faire.com/fastly/e2749ff7b1797b6464390b27c6f0816f694c1b3b4f1cd5cefd1c051f35a1045c.jpeg",
  ],
  priceDollars: 7.86,
  description:
    "Type: pendant necklace\n\nMaterial: 316L Stainless steel ，Cubic zirconia , 18K gold plated\n\nSize of pendant ： 20mm * 26mm\n\nLength of chain ： 400mm + 50mm\n\nProcess: Vacuum electroplating and manual polishing,Non tarnish\n\nSurface : High Polish\n\n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 19.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:14.461Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
